$(function() {
  return $(document).on('keyup', '#client_id', function() {
    searchClient($(this).val())
  })
})

$(function() {
  return $(document).on('keyup', '#employee_name', function() {
    searchEmployee($(this).val())
  })
})

$(function() {
  return $(document).on('keyup', '#product_id', function() {
    searchProducts($(this).val())
  })
})

$(function() {
  return $(document).on('keyup', '#client_city_name', function() {
    searchCity($(this).val())
  })
})

$(function() {
  return $(document).on('keyup', '#employee_city_name', function() {
    searchEmployeeCity($(this).val())
  })
})

$(function() {
  return $(document).on('keyup', '#company_city_name', function() {
    searchCompanyCity($(this).val())
  })
})

$(function() {
  return $(document).on('keyup', '#provider_city_name', function() {
    searchProviderCity($(this).val())
  })
})

function searchProducts(dataToFind) {
  $(".ui-helper-hidden-accessible").css({"position": "absolute", "left":"-999em"}) //Oculta este elemento
  if (dataToFind.length > 0){
    $.getJSON("/search_product/" + dataToFind + ".json", function(result) {
      if (result.length > 0){
        console.log(result)
        $('#product_id').autocomplete({
          source: result,
          autoFocus: true,
          messages: {
            noResults: 'No se encontraron resultados de busqueda',
            results : function(resultsCount) {}
          },
          select: function(event, data_select) {
            $(this).val(data_select.item.label)
            productID = data_select.item.value
            $('#item_product_id').val(productID)

            searchProduct(productID)
            return false
          }
        })
      }
    })
  }
}

function searchClient(dataToFind) {
  $(".ui-helper-hidden-accessible").css({"position": "absolute", "left":"-999em"}) //Oculta este elemento
  if (dataToFind.length > 0){
    $.getJSON("/search_client/" + dataToFind + ".json", function(result) {
      if (result.length > 0){
        $('#client_id').autocomplete({
          source: result,
          autoFocus: true,
          messages: {
            noResults: 'No se encontraron resultados de busqueda',
            results : function(resultsCount) {}
          },
          select: function(event, data_select) {
            $(this).val(data_select.item.label)
            $('#cart_client_id').val(data_select.item.value)
            return false
          }
        })
      }
    })
  }
}

function searchEmployee(dataToFind) {
  $(".ui-helper-hidden-accessible").css({"position": "absolute", "left":"-999em"}) //Oculta este elemento
  if (dataToFind.length > 0){
    $.getJSON("/search_employee/" + dataToFind + ".json", function(result) {
      if (result.length > 0){
        $('#employee_name').autocomplete({
          source: result,
          autoFocus: true,
          messages: {
            noResults: 'No se encontraron resultados de busqueda',
            results : function(resultsCount) {}
          },
          select: function(event, data_select) {
            $(this).val(data_select.item.label)
            $('#employee_id').val(data_select.item.value)
            return false
          }
        })
      }
    })
  }
}

function searchProduct(ProductID) {
  if (ProductID.length > 0){
    $.getJSON("/products/data_product_selected/" + ProductID + ".json", function(result) {
      $("#item_quantity").val(1)
      $("#item_value").val(result.sale_price)
      $("#item_iva_percent").val(parseInt(result.sale_iva))
      $("#item_ico_percent").val(parseInt(result.sale_ico))
      $("#item_iva_value").val(result.sale_iva_value)
      $("#item_ico_value").val(result.sale_ico_value)
      
      $("#item_subtotal").val(result.product_price)
      $("#item_total").val(result.sale_price)

      $(".cart-subtotal").text('$' + Intl.NumberFormat().format(parseFloat(result.product_price)))
      $(".cart-total").text('$' + Intl.NumberFormat().format(parseFloat(result.sale_price)))
    })
  }
}

function searchCity(dataToFind) {
  $(".ui-helper-hidden-accessible").css({"position": "absolute", "left":"-999em"}) //Oculta este elemento
  if (dataToFind.length > 0){
    $.getJSON("/search_city/" + dataToFind + ".json", function(result) {
      if (result.length > 0){
        $('#client_city_name').autocomplete({
          source: result,
          autoFocus: true,
          messages: {
            noResults: 'No se encontraron resultados de busqueda',
            results : function(resultsCount) {}
          },
          select: function(event, data_select) {
            $(this).val(data_select.item.label)
            $('#client_city_id').val(data_select.item.value)
            return false
          }
        })
      }
    })
  }
}

function searchEmployeeCity(dataToFind) {
  $(".ui-helper-hidden-accessible").css({"position": "absolute", "left":"-999em"}) //Oculta este elemento
  if (dataToFind.length > 0){
    $.getJSON("/search_city/" + dataToFind + ".json", function(result) {
      if (result.length > 0){
        $('#employee_city_name').autocomplete({
          source: result,
          autoFocus: true,
          messages: {
            noResults: 'No se encontraron resultados de busqueda',
            results : function(resultsCount) {}
          },
          select: function(event, data_select) {
            $(this).val(data_select.item.label)
            $('#employee_city_id').val(data_select.item.value)
            return false
          }
        })
      }
    })
  }
}

function searchCompanyCity(dataToFind) {
  $(".ui-helper-hidden-accessible").css({"position": "absolute", "left":"-999em"}) //Oculta este elemento
  if (dataToFind.length > 0){
    $.getJSON("/search_city/" + dataToFind + "/colombia" + ".json", function(result) {
      if (result.length > 0){
        $('#company_city_name').autocomplete({
          source: result,
          autoFocus: true,
          messages: {
            noResults: 'No se encontraron resultados de busqueda',
            results : function(resultsCount) {}
          },
          select: function(event, data_select) {
            $(this).val(data_select.item.label)
            $('#company_city_id').val(data_select.item.value)
            return false
          }
        })
      }
    })
  }
}

function searchProviderCity(dataToFind) {
  $(".ui-helper-hidden-accessible").css({"position": "absolute", "left":"-999em"}) //Oculta este elemento
  if (dataToFind.length > 0){
    $.getJSON("/search_city/" + dataToFind + "/colombia" + ".json", function(result) {
      if (result.length > 0){
        $('#provider_city_name').autocomplete({
          source: result,
          autoFocus: true,
          messages: {
            noResults: 'No se encontraron resultados de busqueda',
            results : function(resultsCount) {}
          },
          select: function(event, data_select) {
            $(this).val(data_select.item.label)
            $('#provider_city_id').val(data_select.item.value)
            return false
          }
        })
      }
    })
  }
}
